import { render, staticRenderFns } from "./StepTemplate.vue?vue&type=template&id=2fad11dc&scoped=true"
import script from "./StepTemplate.vue?vue&type=script&lang=js"
export * from "./StepTemplate.vue?vue&type=script&lang=js"
import style0 from "./StepTemplate.vue?vue&type=style&index=0&id=2fad11dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fad11dc",
  null
  
)

export default component.exports